import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Chapters } from "@/components/landing/Chapters";
import { Location } from "@/components/landing/Location";
import { Registration } from "@/components/landing/Registration";
import { Footer } from "@/components/landing/Footer";

const Nav = () => (
  <motion.header
    initial={{ y: -60, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.7, delay: 0.1 }}
    className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-ivory/85 border-b border-petrol/10"
    data-testid="main-nav"
  >
    <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 h-16 flex items-center justify-between">
      <span className="font-mono text-xs sm:text-sm font-semibold tracking-widest text-petrol uppercase">
        AMN<span className="text-coral">·</span>Formazione
      </span>
      <a
        href="#iscrizione"
        data-testid="nav-cta-button"
        className="text-xs sm:text-sm font-semibold bg-coral hover:bg-coralhover text-ivory px-5 py-2.5 rounded-full transition-colors duration-300"
      >
        Iscriviti ora
      </a>
    </div>
  </motion.header>
);

export default function Landing() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    api.get("/config").then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  return (
    <div className="bg-ivory text-ink font-sans overflow-x-clip" data-testid="landing-page">
      <div className="noise-overlay" />
      <Nav />
      <Hero config={config} />
      <Marquee />
      <Chapters />
      <Location config={config} />
      <Registration config={config} />
      <Footer />
    </div>
  );
}
